import { i18n as l506 } from "./i18n/506";
import { i18n as l507 } from "./i18n/507";

export default {
  506: l506,
  507: l507,
};
